// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="text-center text-white text-sm py-4 mt-10 bg-gray-800">
      <p>
        <Link to="/evolutions" style={{ color: "white", textDecoration: "none" }}>
          Évolutions
        </Link>
        &nbsp;|&nbsp;
        <Link to="/faq" style={{ color: "white", textDecoration: "none" }}>
          FAQ
        </Link>
        &nbsp;|&nbsp;
        <Link to="/mentions" style={{ color: "white", textDecoration: "none" }}>
          CGU
        </Link>
        &nbsp;|&nbsp;
        <Link to="/privacy" style={{ color: "white", textDecoration: "none" }}>
          Politique de confidentialité
        </Link>
        &nbsp;|&nbsp;
        <Link to="/mentions-legales" style={{ color: "white", textDecoration: "none" }}>
          Mentions légales
        </Link>
      </p>

      <p className="mt-2 text-gray-400 leading-5">
        💘 <strong>CrushNow®</strong> — marque enregistrée INPI n° <strong>5152773</strong><br />
        Copropriétaire : <strong>Copropriétaire mentionné au certificat INPI</strong><br />
        © {new Date().getFullYear()} Tous droits réservés.
      </p>

      <div style={{ marginTop: "16px" }}>
        <a
          href="/feedback"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            padding: "10px 20px",
            backgroundColor: "#7a3df0",
            color: "white",
            borderRadius: "8px",
            fontWeight: "600",
            textDecoration: "none"
          }}
        >
          Donner mon avis 💬
        </a>
      </div>

    </footer>
  );
};

export default Footer;
